export default __webpack_public_path__ + "static/media/EM0760.34I-22661_-15273_0.71c3dadf.jpg";